import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Container } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQ = () => {
  const faqSections = [
    {
      title: "الاشتراك وطرق الدفع",
      questions: [
        {
          q: "كيف يمكنني الاشتراك في أوديوهات؟",
          a: "تستطيع اختيار الباقة وطريقة الدفع من خلال الذهاب الى (صفحتي – الاشتراكات). أو من خلال موقعنا https://audiohatdar.com"
        },
        {
          q: "ماهى مميزات الاشتراك في تطبيق أوديوهات؟",
          a: "1. تحميل الحلقات والاستماع اليها بدون انترنت.\n2. حفظ سجل الاستماع ومواصلة الاستماع من مكان التوقف.\n3. إضافة المحتوى إلى قائمة المفضلة لديك.\n4. التعليق والمشاركة في تقييم المحتوى."
        },
        {
          q: "ماهي طرق الدفع المتاحة للاشتراك في التطبيق؟",
          a: "1. البطاقات الائتمانية (فيزا – ماستر كارد – ميزة .. الخ)\n2. فوري\n3. Google Pay\n4. Apple Pay\n5. PayPal\n6. تقدم فودافون كاش خدمة طلب فيزا افتراضية صالحة لمدة 24 ساعة يمكن استخدامها في شراء باقات الفيزا في أوديوهات."
        },
        {
          q: "كيف يمكنني الدفع عن طريق فوري؟",
          a: "بالضغط على الباقة المختارة واختيار الدفع بفوري، ثم ملء البيانات. سيتم ارسال كود على موبايلك وايميلك (الكود صالح لمدة 48 ساعة فقط) .. توجه الى أقرب منفذ فوري واستخدم الكود لتدفع قيمة الاشتراك على خدمة رقم 788 .. انتهى .. تم الاشتراك."
        },
        {
          q: "هل أستطيع شراء أكثر من باقة في وقت واحد للحصول على مدة اشتراك أطول؟",
          a: "لن يكون هذا مفيدا، حيث أن مدد الاشتراك ليست تراكمية. تبدأ الباقة في السريان من تاريخ دفع قيمة الاشتراك، وليس من تاريخ نهاية الباقة السارية إن وجدت."
        },
        {
          q: "ماهو الاختلاف في مزايا الباقات المتاحة؟",
          a: "جميع الباقات توفر نفس المزايا، الفرق بين الباقات هو فقط فترة الاشتراك التي تمنحها كل باقة."
        }
      ]
    },
    {
      title: "ادارة اشتراكك",
      questions: [
        {
          q: "لمستخدمي الآيفون: تم خصم قيمة الباقة ولم يتم تفعيل حسابي!",
          a: "لتنشيط اشتراكك من خلال أبل نرجو منك الدخول في التطبيق الى (صفحتي) ثم (الاشتراكات) ثم (اعادة تفعيل المشتريات)."
        },
        {
          q: "لمستخدمي الأندرويد (جوجل باي): تم خصم قيمة الباقة ولم يتم تفعيل حسابي!",
          a: "لتنشيط اشتراكك من خلال جوجل نرجو منك الدخول في التطبيق الى (صفحتي) ثم (الاشتراكات) ثم (الدفع من خلال جوجل باي) ثم (اعادة تفعيل المشتريات)."
        },
        {
          q: "لمستخدمي الأندرويد (فوري/فيزا): تم خصم قيمة الباقة ولم يتم تفعيل حسابي!",
          a: "قد تحتاج فقط الى غلق التطبيق وفتحه ثانية للتنشيط\nاذا استمرت المشكلة تواصل مع ايميل الدعم support@audiohatdar.com"
        },
        {
          q: "كيف أستطيع الغاء الاشتراك؟",
          a: "اذا كنت مشترك من خلال حساب itunes الخاص بجهازك الايفون:\nقم الدخول الى المتجر App Store / ثم الضغط على صورة حسابك (أعلى يمين الشاشة) / ثم الاشتراكات Subscriptions / ثم اختار \"أوديوهات\" / ثم قم بالضغط على (الغاء الاشتراك) Cancel Subscription\n\nاذا كنت مشترك من خلال الموقع أو جهاز أندرويد:\n- قم بتسجيل الدخول إلى audiohatdar.com وانتقل إلى (حسابى)\n- اضغط على (اشتراكات) / ثم قم بالضغط على زر (الغاء) أمام باقة اشتراكك الحالية\n- قم بالذهاب الى الصفحة الرئيسية واختيار الباقة الجديدة التي ترغب في الاشتراك من خلالها."
        }
      ]
    },
    {
      title: "المحتوى على التطبيق",
      questions: [
        {
          q: "هل يوجد معدل ثابت لانتاج الحلقات؟",
          a: "قد يكون هذا ممكنا في حالة الكتاب الصوتي الذي يقرأه راوي واحد بطريقة سردية، ولكن من الصعب جدا انتاج محتوى درامي بمعدل ثابت. حيث توجد العديد من العوامل التي تؤثر على مدة الانتاج مثل حجم الرواية وعدد الشخصيات ونوع المؤثرات الصوتية المطلوبة تبعا لأحداث الرواية وغيرها كثيرا.\n\nهذا النوع من المحتوى أقرب لانتاج الأفلام والمسلسلات. علما بأننا نعمل دائما بأقصى طاقتنا لتسريع وتيرة الانتاج دون التأثير على جودة المحتوى المقدم."
        },
        {
          q: "لماذا لا تقدمون المحتوى بشكل مجاني بالكامل؟",
          a: "لأننا نقدم محتوانا من خلال اتفاقات قانونية مع الناشرين والمؤلفين. كما أنه لابد من وجود عائد مادي لتغطية تكاليف انتاج المحتوى بجودة عالية، وتكاليف تشغيل التطبيق. مما يساعد على الاستمرارية في تقديم المحتوى. علما بأننا نقدم مجموعة متنوعة من الباقات لتلائم الجميع."
        }
      ]
    },
    {
      title: "الانضمام الى فريق أوديوهات",
      questions: [
        {
          q: "كيف أنضم الى فريق أوديوهات الصوتي؟",
          a: "نرحب دائما بضم أصوات جديدة لفريقنا لتحقيق تنوع وجودة أعلى للمحتوى، وبالتالي متعة أكبر للمستمعين. يمكنك ارسال تجربة الأداء الخاصة بأوديوهات، والمتاحة داخل التطبيق في (صفحتي – انضم لفريق أوديوهات الصوتي)."
        },
        {
          q: "كيف أنضم الى فريق أوديوهات الفني؟",
          a: "تستطيع الانضمام للفريق الفني لأوديوهات والمعني ب (تصميم البوسترات للحلقات – الضبط اللغوي – هندسة الصوت) عن طريق التواصل معنا عبر الايميل Support@audiohatdar.com"
        }
      ]
    },
    {
      title: "عام",
      questions: [
        {
          q: "التطبيق يتوقف كلما أقفلت شاشة الموبايل",
          a: "الرجاء التأكد من اعطاء الاذن لتطبيق أوديوهات بالعمل في الخلفية، وذلك من داخل اعدادت جهازك نفسه والخاصة بالحفاظ على البطارية."
        },
        {
          q: "هل ستبقى الحلقات التي قمت بتحميلها موجودة بعد انتهاء فترة اشتراكي؟",
          a: "لا. تختفي الحلقات من قائمة التحميلات لديك بعد انتهاء مدة الاشتراك حيث أن الاستماع للحلقات أوفلاين من مزايا الاشتراك المدفوع."
        },
        {
          q: "هل متاح تثبيت التطبيق على الويندوز وسماع الحلقات من خلال جهاز الكمبيوتر؟",
          a: "لا .. لا تتوفر نسخة من التطبيق لنظام الويندوز. التطبيق متوفر على أبل ستور وجوجل بلاي وآب جاليري.\n\nإذا لم تتمكن من تحميل التطبيق، فقد لا يكون جهازك متوافقًا.\nيرجى التأكد من تثبيت آخر تحديث لنظام التشغيل المثبت على جهازك."
        }
      ]
    }
  ];

  return (
    <Container maxWidth="lg" className="py-8 pt-24">
      <Box className="text-center mb-8">
        <Typography variant="h3" component="h1" className="text-white mb-4">
          الأسئلة المتكررة
        </Typography>
        <Typography variant="subtitle1" className="text-gray-400">
          إجابات على أكثر الأسئلة شيوعاً
        </Typography>
      </Box>

      {faqSections.map((section, sectionIndex) => (
        <Box key={sectionIndex} className="mb-8">
          <Typography variant="h4" component="h2" className="text-white mb-4">
            {section.title}
          </Typography>
          {section.questions.map((item, index) => (
            <Accordion
              key={index}
              className="bg-neutral-800 mb-2"
              sx={{
                '&:before': {
                  display: 'none',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="text-white" />}
                className="text-white hover:bg-neutral-700"
              >
                <Typography>{item.q}</Typography>
              </AccordionSummary>
              <AccordionDetails className="bg-neutral-700">
                <Typography className="text-gray-300 whitespace-pre-line">{item.a}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      ))}
    </Container>
  );
};

export default FAQ; 